
const VidOff =()=>{
    return(
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
	<path fill="#000" d="M3.17 6.43a.27.27 0 0 0-.28 0A1.5 1.5 0 0 0 2 7.75v9a1.5 1.5 0 0 0 1.5 1.5h10.88a.25.25 0 0 0 .23-.15a.26.26 0 0 0 0-.28Zm18.57 1.02l-3 1.71a1.44 1.44 0 0 0-.74 1.25v3.68a1.44 1.44 0 0 0 .74 1.25l3 1.71A1.5 1.5 0 0 0 24 15.8V8.7a1.5 1.5 0 0 0-2.26-1.25" />
	<path fill="#000" d="M17.07 15.66a.3.3 0 0 1-.07-.18V7.75a1.5 1.5 0 0 0-1.5-1.5H7.77a.3.3 0 0 1-.18-.07L1.71.29A1 1 0 0 0 .44.17L.29.29a1 1 0 0 0 0 1.42l22 22a1 1 0 0 0 1.42-1.42Z" />
</svg>
)
}
export default VidOff;